import { Tracing } from "@tento-core/tracing";

/** Match Lona's ux-trace event contract without depending on its app shell. */
export function installUxTraceDoor(): void {
  document.addEventListener("ux-trace", (event: Event) => {
    const detail = (event as CustomEvent<{ probe: string; report: string }>).detail;
    const probe = typeof detail?.probe === "string" ? detail.probe : "";
    const report = typeof detail?.report === "string" ? detail.report : "";
    Tracing.log("ux-trace", { probe, report });
  });
}
